import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { JobsProvider } from "./jobs";
import "./index.css";

// Inject Material Symbols font
const link = document.createElement("link");
link.rel = "stylesheet";
link.href = "https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=block";
document.head.appendChild(link);

// Inject Geist font
const geist = document.createElement("link");
geist.rel = "stylesheet";
geist.href = "https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700&family=Geist+Mono:wght@400;500&display=swap";
document.head.appendChild(geist);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <JobsProvider>
      <App />
    </JobsProvider>
  </React.StrictMode>
);